import React from "react";
import { Grid, Typography } from "@mui/material";

import { ProjectSPModel } from "../../../models/ProjectSPModel";
import { displayDateFormart } from "../../../utility/utils";

interface IBidDetailsSection {
  data: ProjectSPModel;
}

export const BidDetailsSection = (props: IBidDetailsSection) => (
  <Grid container spacing={1}>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Funding Source
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.fundingSource) || "NA"}
      </Typography>
    </Grid>
    {props.data.fundingSource === "Others" && (
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Other Funding Source
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.otherFundingSource) || "NA"}
        </Typography>
      </Grid>
    )}
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Tender Expected - Indicative
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && displayDateFormart(props.data.tenderExpectedDate)) ||
          "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Award Expected - Indicative
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && displayDateFormart(props.data.awardExpectedDate)) ||
          "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Project Duration
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {props.data && props.data.projectDuration} months
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Estimated time to bid
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {props.data && props.data.estimatedTimeToBid}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        O&M part of scope?
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {props.data && props.data.isOM ? "Yes" : "No"}
      </Typography>
    </Grid>
    {props.data.isOM === true && (
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          O&M Duration
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.omduration}
        </Typography>
      </Grid>
    )}
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Tendering Bandwidth
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.tenderingBandwidth) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Tender Maturity
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.tenderMaturity) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Country
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.country) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        State
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.state) || "Na"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        City
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.city) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Location
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.location) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Environment Clearance Status
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.environmentClearanceStatus) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        ROW Status
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.rowstatus) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Geography
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.geography) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Competition Intensity
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.competitionIntensity) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Proposal Stage
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.proposalStage) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Competitors executing work with client
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.competitorsWithClient) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Win strategy and value proposition
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.winStrategyAndValueProposition) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Country corruption rating (TCPI)
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.countryCorruptionRating) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
        Time to PQ (Days)
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.timeToPqdays) || "NA"}
      </Typography>
    </Grid>
  </Grid>
);
